export default __webpack_public_path__ + "static/0242-ed997013fb5391fc3ae6f7b8b345eadc.png";